<template>
  <template v-if="!isLoading">
    <h2 id="commentsTitle" class="sr-only">Comments</h2>
    <CommentsList v-if="id" :itemId="id" />
    <CommentsAdd @addedComment="($event: CommentAddedEvent) => emit('addedComment', $event)" v-if="isLoggedIn || allowAnonymousComments" />
    <LoginInfo class="mt-4" v-if="!isLoggedIn && !allowAnonymousComments && list.length" />
  </template>
  <Skeleton v-else />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { watch, onMounted } from 'vue';
import { useUserStore } from '@/store/useUserStore';
import { useCommentsStore } from '@/modules/viewer/store/useCommentsStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

import CommentsList from './List.vue';
import CommentsAdd from './Add.vue';
import LoginInfo from './LoginInfo.vue';
import Skeleton from './Skeleton.vue';

const userStore = useUserStore();
const commentsStore = useCommentsStore();
const viewerItemStore = useViewerItemStore();
const { isLoggedIn } = storeToRefs(userStore);
const { id, allowAnonymousComments } = storeToRefs(viewerItemStore);
const { isLoading, list } = storeToRefs(commentsStore);

type CommentAddedEvent = { comment: string };
const emit = defineEmits<{ addedComment: [CommentAddedEvent] }>();

const loadComments = () => id?.value && commentsStore.load(id?.value);
watch(id, loadComments);
onMounted(() => loadComments());
</script>
